// api
import { fetchApi } from '@/api'
// actions
const inventoryProductsCategoriesAll = (context) => {
  let url = 'inventory/products/categories'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_CATEGORIES_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsCategoriesForm = (context) => {
  let url = 'inventory/products/categories/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_CATEGORIES_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsCategoriesShow = (context, payload) => {
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'inventory/products/categories/' + obj.id + '/edit'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_CATEGORIES_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsCategoriesCreate = (context, payload) => {
  let url = 'inventory/products/categories'
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_CATEGORIES_CREATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsCategoriesUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/categories/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_CATEGORIES_UPDATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProductsCategoriesDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/categories/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('INVENTORY_PRODUCTS_CATEGORIES_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  inventoryProductsCategoriesAll,
  inventoryProductsCategoriesForm,
  inventoryProductsCategoriesShow,
  inventoryProductsCategoriesCreate,
  inventoryProductsCategoriesUpdate,
  inventoryProductsCategoriesDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/inventory/products/categories/actions.js